import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ReactDateRangeWrapper } from '../common/components/DateRangeComponent/ReactDateRangeWrapper';

import { Grid, Tooltip } from '@material-ui/core';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import { AppTheme, AppStyles } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import { BaseEntityPage } from '../common/components/BaseEntityPage';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { SearchBar } from '../common/components/SearchBar';
import { AppConfig } from '../AppConfig';
import { Button } from '@material-ui/core';
import { AppHelper } from '../helpers/AppHelper';
import { pSections, userFields } from '../data/data';

export class Stats extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.noAdd = true
    this.pageTitle = 'Signups'
    this.quizId = AppConfig.quizId
    this.state.dateRangeOptions = {
      id: 'Today',
      startDate: moment().startOf('day'),
      endDate: moment()
    }
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Survey' },
    ]
    this.tableHeadersMap = {
      Index: (current) => {
        return <span className={css(Styles.spanValue)}>{current.__index + 1}</span>
      },
      User: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.email}</span>
            <br />
            <span className={css(Styles.spanValue)}>
              {(Helper.formatName(current) || 'UNKNOWN') + ' | Joined on ' + Helper.formatTimestamp(current.createdTs)}</span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.preferedQSections ? current.preferedQSections.length + ' Preferred Sections' : ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {this.subSectionCount(current.preferedQSections) + ' Preferred Sub Sections'}
            </span>
            <br />
            {current.responseId &&
              <span className={css(Styles.spanValue)}>RID | {current.responseId}</span>
            }
            <br />
            {current.internalUser &&
              <span className={css(Styles.spanValue)}>Internal User | {current.internalUser}</span>
            }
          </div>
        )
      },
      Progress: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>
              {current.completedSectionIds ? current.completedSectionIds.length + ' Sub Sections' : ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.completedSectionTs ? 'Latest on ' + Helper.formatDate(current.completedSectionTs) : ''}
            </span>
          </div>
        )
      },
      Consent: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>
              {current.consentSignIP || ''}
            </span>
            <br />
            <span className={css(Styles.spanValue)}>
              {current.consentSignTs ? 'Consent on ' + Helper.formatDate(current.consentSignTs) : ''}
            </span>
            <br />
            <div className={css(Styles.detailContainer)} >
              {current.dob &&
                <span className={css(Styles.spanValue)}>
                  DOB | {current.dob} {this.findAge(current)}
                </span>
              }
              {AppHelper.calculateAgeBasedonUserCreatedTs(current) < 18 && AppHelper.calculateAgeBasedonUserCreatedTs(current) >= 13 &&
                <Tooltip title='Add sections' placement='top-start' key={current.id + 'editTT'}>
                  <span className={css(AppStyles.entityTableLinkIcon)}>
                    <i className='material-icons' onClick={() => this.openModalForEdit(current, pSections.fieldDef)}>subdirectory_arrow_right</i>
                  </span>
                </Tooltip>
              }
            </div>
            <div className={css(Styles.detailContainer)} >
              {current.consentGuardianName &&
                <span className={css(Styles.spanValue)}>
                  Guardian Name - {current.consentGuardianName}
                </span>
              }
            </div>
            <div className={css(Styles.detailContainer)} >
              {current.consentGuardianEmail &&
                <span className={css(Styles.spanValue)}>
                  Guardian Email - {current.consentGuardianEmail}
                </span>
              }
            </div>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {}
    this.export = {
      headers: {
        __index: 'Index', name: 'Name', phone: 'Phone', email: 'Email',
        dob: 'DOB', address: 'Address', responseId: 'Response ID', state: 'State',
        completedSectionIds: 'Completed Subsections',
        completedSectionTs: 'Completed SubSection Ts',
        preferedQSections: 'Prefered Surveys',
        consentSignIP: 'Consent Sign IP', consentSignTs: 'Consent Sign Ts',
        completedSubsectionsCount: 'Completed SubSections Count',
        preferredSectionsCount: 'Preferred Sections Count',
        preferredSubSectionsCount: 'Preferred SubSections Count',
      },
      format: 'xlsx'
    }
    this.surveyTitleById = {}
    this.surveySubsectionTitleById = {}
  }

  exportRowItemValue(key, current) {
    switch (key) {
    case '__index':
      return current.__index + 1
    case 'name':
      return Helper.formatName(current)
    case 'address':
      return AppHelper.formatAddress(current)
    case 'completedSectionIds':
      return this.getSurveySubsectionNamefromId(current.completedSectionIds)
    case 'completedSectionTs':
      if(current.completedSectionTs) {
        return Helper.formatTimestamp(current.completedSectionTs)
      } else {
        return ''
      }
    case 'preferedQSections':
      return this.getSurveyNamefromId(current.preferedQSections)
    case 'consentSignTs':
      if(current.consentSignTs) {
        return Helper.formatTimestamp(current.consentSignTs)
      } else {
        return ''
      }
    case 'completedSubsectionsCount':
      return current.completedSectionIds ? current.completedSectionIds.length : 0
    case 'preferredSectionsCount':
      return current.preferedQSections ? current.preferedQSections.length : 0
    case 'preferredSubSectionsCount':
      return this.subSectionCount(current.preferedQSections)
    default:
      return current[key]
    }
  }

  getSurveyNamefromId = (ids) => {
    if(!ids) return ''
    const titles = []
    if (ids) {
      for (const id of ids) {
        if (!this.surveyTitleById[id]) continue
        titles.push(this.surveyTitleById[id].title)
      }
    }
    return AppHelper.arrToCsv(titles)
  }

  getSurveySubsectionNamefromId = (ids) => {
    if(!ids) return ''
    const titles = []
    for (const id of ids) {
      if (!this.surveySubsectionTitleById[id]) continue
      titles.push(
        this.surveySubsectionTitleById[id].title + '(Survey: ' + this.surveySubsectionTitleById[id].parentTitle + ')'
      )
    }
    return AppHelper.arrToCsv(titles)
  }

  generateSurveyDict = (items) => {
    if (items && items.sections) {
      for (const item of items.sections) {
        const section = {
          title: item.title,
          subSectionCount: 0
        }
        this.surveyTitleById[item.id] = section
        if (!item.subsections) continue
        section.subSectionCount = item.subsections.length
        for (const ss of item.subsections) {
          this.surveySubsectionTitleById[ss.id] = {
            title: ss.title,
            parentTitle: item.title,
          }
        }
      }
    }
  }

  subSectionCount(sectionIds) {
    let count = 0
    sectionIds && sectionIds.forEach(i => {
      if(this.surveyTitleById[i]) {
        count += this.surveyTitleById[i].subSectionCount
      }
    })
    return count
  }

  findAge = (appUser) => {
    const age = AppHelper.calculateAgeBasedonUserCreatedTs(appUser)
    if (age < 13) {
      return '(CHILD)'
    } else if (age >= 13 && age < 18) {
      return '(MINOR)'
    }
  }

  openModalForEdit(current, fieldDef) {
    //console.log('edit:', current);
    this.formDefinition = fieldDef || this.fieldDef || this.formDefinition
    this.formDefinition.formType = 'edit'

    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current);
    this.setState({
      modalOpen: true
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['users', current.id]),
    });
  }

  customSubmit(options) {
    const { formType, formData, caller } = options

    const jsonBody = {}
    if(formData.internalUser === 'YES') {
      jsonBody.updateAction = 'markInternalUser'
    } else if(formData.internalUser === 'NO') {
      jsonBody.updateAction = 'unMarkInternalUser'
    } else if(formData.preferedQSections) {
      jsonBody.preferedQSections = formData.preferedQSections
      jsonBody.updateAction = 'preferedQSections'
    } else {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('unsupportedFunctionality'),
        success: false,
        message: Helper.getString('unsupportedFunctionality'),
        inProcess: false
      })
      return
    }
    ApiHelper.call({
      method: this.state.apiMethod,
      endPoint: this.state.apiEndPoint,
      jsonBody
    },
    async (err, data) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err);
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        this.apiData = {}
        return;
      }
      caller.setState({
        success: true,
        message: '',
        inProcess: false
      })
      this.apiData = {}
      if (caller.props.onClosed) {
        caller.props.onClosed();
      }
      if(this.state.searchText) {
        this.onSearch(this.state.searchText)
      } else {
        this.fetchItems()
      }
    })
  }

  fetchSections = () => {
    ApiHelper.call(
      { method: 'GET', paths: ['miscs', 'quiz-sections'], queryParams: { quizId: AppConfig.quizId } },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        const baselines = []
        const optionals = []
        const mandatory = []
        const sections = []
        if (results && results[0].sections) {
          for (const item of results[0].sections) {
            if (item.baseline === 'YES' || item.baseline === 'BASELINE') {
              baselines.push(item)
              sections.push({
                key: item.id,
                label: item.title,
                value: true
              })
            } else if (item.baseline === 'MANDATORY') {
              mandatory.push(item)
              sections.push({
                key: item.id,
                label: item.title,
                value: true
              })
            } else {
              optionals.push(item)
              sections.push({
                key: item.id,
                label: item.title,
                value: false
              })
            }
          }
        }

        console.log('sections', sections)
        this.setState({
          optionals: optionals,
          baselines: baselines,
          mandatory: mandatory,
        })
        pSections.fieldDef.steps[0].fields[0].options = sections
        console.log('onFetchSuccess', results)
      }.bind(this))
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.container)}>
        <Grid container className={css(Styles.containerNarrow)}>
          <Grid item sm={12} xs={12}>
            <SearchBar
              placeholder={'Enter email'}
              onSearch={this.onSearch.bind(this)}
              searchText={this.state.searchText}>
            </SearchBar>
            {/* <div className={css(Styles.datePickerContainer)}>
              <div className={css(Styles.datePickerInnerContainer)}>
                <Grid item xs={6} sm={4}>
                  <DatePicker
                    selected={this.state.selectedDate || new Date()}
                    onChange={this.onDateChange.bind(this)}
                    showMonthYearPicker={true}
                    dateFormat='MMM-yyyy'
                  />
                </Grid>
                <Grid className={css(Styles.rightGridPadding)} item xs={6} sm={2}>
                  <Button
                    className={css(Styles.button, Styles.emailSearchButton)}
                    variant='contained' color='primary' onClick={() => this.fetchItems()}>
                    Show all users
                  </Button>
                </Grid>
              </div>
            </div> */}
          </Grid>
        </Grid>
      </div>
    )
  }

  onSearch = (searchText) => {
    this.setState({
      searchText: searchText,
      fetchState: ApiHelper.State.LOADING
    })
    ApiHelper.call({ method: 'GET', paths: ['users'], queryParams: { email: searchText } }, (err, result) => {
      if (err) {
        console.log('Search Error', err)
      }
      const items = result ? [result] : []
      this.setState({
        items: items,
        nextPage: '',
        fetchState: ApiHelper.State.READY
      })
    })
  }

  onDateChange = date => {
    this.setState({
      selectedDate: date,
      searchText: ''
    })
  }

  fetchItems() {
    this.setState({
      searchText: ''
    })
    const ts = 1637659248024
    const queryParams = {
      startTs: moment(this.state.dateRangeOptions.startDate).valueOf(),
      endTs: moment(this.state.dateRangeOptions.endDate).valueOf(),
      // endTs: ts,
      // startTs: ts - (3600 * 1000 * 24),
      quizId: this.quizId
    }
    this.toFetch = [
      {
        // method: 'GET', paths: ['miscs/user-progress'],
        //   queryParams: { createdYm: moment(this.state.selectedDate).format('YYYYMM'), quizId: this.quizId }
        method: 'GET', paths: ['miscs/user-progress'], queryParams: queryParams
      },
      {
        method: 'GET', paths: ['miscs', 'quiz-sections'],
        queryParams: { quizId: AppConfig.quizId }
      },
    ]
    return super.fetchItems()
  }

  onFetchSuccess(results) {
    this.generateSurveyDict(results[1])
    const baselines = []
    const optionals = []
    const mandatory = []
    const sections = []
    if (results && results[1].sections) {
      for (const item of results[1].sections) {
        if (item.baseline === 'YES' || item.baseline === 'BASELINE') {
          baselines.push(item)
          sections.push({
            key: item.id,
            label: item.title,
            value: true
          })
        } else if (item.baseline === 'MANDATORY') {
          mandatory.push(item)
          sections.push({
            key: item.id,
            label: item.title,
            value: true
          })
        } else {
          optionals.push(item)
          sections.push({
            key: item.id,
            label: item.title,
            value: false
          })
        }
      }
    }

    pSections.fieldDef.steps[0].fields[0].options = sections
    this.handleNextpage(results[0])
    this.setState({
      optionals: optionals,
      baselines: baselines,
      mandatory: mandatory,
      items: results[0].items,
      headerActionComponents: [this.dateRangeComponent()],
    })
  }

  dateRangeComponent() {
    return (
      <ReactDateRangeWrapper key='dateTimeRangePicker'
        onDateRangeChange={this.onDateRangeChange}
        initialRange={this.state.dateRangeOptions}>
      </ReactDateRangeWrapper>
    )
  }

  onDateRangeChange = (dateRangeOptions) => {
    this.setState({ dateRangeOptions }, () => {
      this.fetchItems()
    })
  }

  onFetchNextSuccess(results) {
    this.handleNextpage(results[0])
    this.setState({
      items: this.state.items.concat(results[0].items),
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  buttonEdit(current, fieldDef) {
    return (
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.openModalForEdit(current, fieldDef)}>edit</i>
        </span>
      </Tooltip>
    )
  }

  onActions = (current) => {
    const actions = []
    actions.push(this.buttonEdit(current, userFields.fieldDef))
    return actions
  }
}

const Styles = StyleSheet.create({
  container: {
    //position: 'fixed',
    top: AppTheme.toolbarHeight,
    minHeight: AppTheme.toolbarHeight,
    paddingTop: 10,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    marginBottom: 5,
    //zIndex: 1000
  },
  containerNarrow: {
    maxWidth: AppTheme.viewPort,
  },
  title: {
    color: 'black',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 24
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  datePickerContainer: {
    backgroundColor: 'white',
    alignItems: 'center',
    minHeight: AppTheme.toolbarHeight * 2 / 3,
    display: 'flex',
    // backgroundColor: 'white',
    width: '100%',
    marginBottom: 16,
    maxWidth: AppTheme.viewPort,
  },
  rightGridPadding: {
    paddingLeft: 10
  },
  datePickerInnerContainer: {
    display: 'flex',
    padding: 15,
    flex: 1,
    alignItems: 'center'
  },
  button: {
    boxShadow: 'none',
    // marginLeft : 10,
    minWidth: 150
  },
  detailContainer: {
    display: 'flex',
    alignItems: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/screens/Stats.js